/* unplugin-vue-components disabled */import script from "./ContractManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractManagement.vue?vue&type=script&setup=true&lang=js"

import "./ContractManagement.vue?vue&type=style&index=0&id=6fab8e6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fab8e6b"]])

export default __exports__